import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import './App.css';
import { Metric } from 'web-vitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // Removing StrictMode for production as it causes double renders in development
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// Enable performance monitoring
reportWebVitals((metric: Metric) => {
  // Log metrics to console during development
  console.log(`${metric.name}: ${metric.value}`);

  // You can also send these metrics to an analytics service like Google Analytics
  // Example: if (window.gtag) window.gtag('event', metric.name, { value: metric.value })
});
